import React, { Component } from "react";
import { IReducerState } from "../../../states/renditionStates";
import { connect } from "react-redux";
import RenditionUrlGenerator from "../../../utils/api/renditionUrlGenerator";
import _, { isEmpty } from "lodash";
import RSCH_HTML_TRACKING_CONFIG from "../../../readership/trackingConfig";
import { addParam, getCVFrameUrl } from "../../../utils/general/general";
import { getStaticEPFAccessToken } from "../../../utils/general/EpfTokensUtils";

interface ICompanyDashboardProps {
  docHeaderSectionJson: any;
  multiCompanyMetaData?: { companyCode: string; ticker: string };
  isExternalUser?: boolean;
  menuCode: any;
}

export class CompanyDashboard extends Component<ICompanyDashboardProps, any> {
  constructor(props: ICompanyDashboardProps) {
    super(props);
  }

  public render() {
    const { docHeaderSectionJson, multiCompanyMetaData, isExternalUser } = this.props;
    const environment = window.HTML_RENDITION.initialData.environment;
    const companyDashboardLabel = docHeaderSectionJson.i18n.companyDashboard;
    let ticker = docHeaderSectionJson.metadata.ticker;
    if (window.HTML_RENDITION.isMCN) {
      if (!_.isEmpty(multiCompanyMetaData)) {
        ticker = multiCompanyMetaData.ticker;
      }
    }
    
    let companyUrl = `/directory/eppublic/company23/${ticker}/index.html`;
    const epfToken =  getStaticEPFAccessToken();
    if (!isEmpty(epfToken)) {
      companyUrl = addParam(companyUrl, '__epftoken', epfToken);
    }
    let dashboardUrl = getCVFrameUrl(this.props.menuCode, companyUrl, 'company_dir');
    if (isExternalUser) {
      dashboardUrl = RenditionUrlGenerator.URL_GENERATOR.environments(environment) + companyUrl;
    }

    return (
      <React.Fragment>
        <div
          className="globalThememachine"
          onClick={() => {            
            RSCH_HTML_TRACKING_CONFIG.trackRequestCompanyDashboardClick();
            window.open(dashboardUrl, isExternalUser ? "_self" : "_blank");
          }}
          onKeyPress={(e) => {            
            RSCH_HTML_TRACKING_CONFIG.trackRequestCompanyDashboardClick();
            window.open(dashboardUrl, isExternalUser ? "_self" : "_blank");
          }}
        >
          <span className="icon-svg-parent">
            <span
              className="icon-svg icon-company-dashboard-svg"
              role="img"
              aria-label={companyDashboardLabel}
            />
          </span>
          <a
            tabIndex={0}
            role="link"
            className="x-rsch-hyperlink"
            aria-label={companyDashboardLabel}
          >
            {companyDashboardLabel}
          </a>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: IReducerState) => {
  return {
    docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
    multiCompanyMetaData: state.commonStateReducer.multiCompanyMetaData,
    menuCode: state.commonStateReducer.menuCode,
  };
};

export default connect(mapStateToProps)(CompanyDashboard);
